import { jsx as _jsx } from "react/jsx-runtime";
import { HorizontalBarChart, TileFooter, TileCard, } from '@cmd/ui-components';
import { useGetData } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { getTopInStockVehiclesBySourceLink, topStockDataFormatter } from './topInStockVehiclesByLeadsUtils';
const tileConfigs = {
    [LeadsDataSource.DDC]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
    [LeadsDataSource.VIN_SOLUTIONS]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_VIN_SOLUTIONS',
            defaultMessage: 'VinSolutions',
        }),
    },
};
const TopInStockVehiclesByLeads = ({ source, limit = 10, 'data-testid': dataTestId }) => {
    const intl = useIntl();
    const testId = dataTestId ? `${dataTestId}-top-in-stock` : 'ids-top-in-stock';
    const { sourceMessage } = tileConfigs[source] || { sourceMessage: () => '' };
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    const params = {
        orgId,
        ...dateRange,
        limit,
    };
    const endpoint = `${source}/${LeadsResource.TOP_IN_STOCK}`;
    const { data, isLoading, error } = useGetData(() => leadsApi[endpoint].get(params, {
        headers: {
            accept: 'application/vnd.coxauto.v2+json',
        },
    }), params, topStockDataFormatter);
    const { lastUpdatedUTC, chartData } = data || {};
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'TOP_IN_STOCK_VEHICLES_TILE_TITLE',
            defaultMessage: 'Top In Stock Vehicles by Leads',
        }), description: intl.formatMessage({
            id: 'TOP_IN_STOCK_VEHICLES_TILE_DESC',
            defaultMessage: 'Lead count for your highest interest inventory',
        }), className: "top-in-stock", error: !!error, isLoading: isLoading, noData: (chartData || []).length === 0, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getTopInStockVehiclesBySourceLink(source, dateRange), "data-testid": testId, lastUpdated: new Date(lastUpdatedUTC || '') })), children: _jsx(HorizontalBarChart, { data: chartData || [], "data-testid": testId }) }));
};
export default TopInStockVehiclesByLeads;
